export const PAYPAL = 'Paypal';
export const BANK_TRANSFER = 'BankAccount';

export const STRIPE_CONNECT = 'StripeConnectExpress';

export type PayoutMethod = {
  id: string;
  name: string;
  benefits: string[];
  description: string;
  enabled: boolean;
};

export interface PayoutMethodsByCountryApi {
  meta: {
    type: 'payment-options-by-country';
    defaultOptions: PayoutMethod[];
  };
  data: {
    countryCode: string;
    id: string;
    availableMethods: PayoutMethod[];
  }[];
}

export interface PayoutMethodsApi {
  meta: {
    type: 'payment-options';
    countryCode: string;
  };
  data: PayoutMethod[];
}
